import React, { useState, useCallback } from 'react';
import styles from './index.module.less';
import $i18n from '@/i18n/index';
import { Table, Tooltip, Icon, Radio, Message, Tree, Input } from '@b-design/fusion';
import Button from '@/components/Button';
import { Upload } from '@alifd/next';
import Confirm from '@/components/Confirm';
import TreeHeader from './components/treeHeader';
const TreeNode = Tree.Node;

const x = 3;
const y = 2;
const z = 1;
const gData = [];

const generateData = (_level, _preKey, _tns) => {
  const preKey = _preKey || '0';
  const tns = _tns || gData;

  const children: string[] = [];
  for (let i = 0; i < x; i++) {
    const key = `${preKey}-${i}`;
    tns.push({ label: key, key, document: { en: '', zh: '' } });
    if (i < y) {
      children.push(key);
    }
  }

  if (_level < 0) {
    return tns;
  }

  const level = _level - 1;
  children.forEach((key, index) => {
    tns[index].children = [];
    return generateData(level, key, tns[index].children);
  });
};

generateData(z, undefined, undefined);

const _loop = (data, key, callback) => {
  data.forEach((item, index, arr) => {
    if (item.key === key) {
      return callback(item, index, arr);
    }
    if (item.children) {
      return _loop(item.children, key, callback);
    }
  });
};

export default function DocumentSetting() {
  //  TODO:ts
  const [dataSource, setDataSource] = useState<any[]>(gData);

  // expandedKeys
  const [expandedKeys, setExpandedKeys] = useState<string[]>([]);

  // 正在修改名称的key
  const [editKey, setEditKey] = useState<string | null>();
  // 正在上传文档的key
  const [editDocumentKey, setEditDocumentKey] = useState<string | null>();

  // 中英文切换
  const [siteLanguage, setSiteLanguage] = useState<'en' | 'zh'>('en');

  const siteLanguageRadio = (
    <Radio.Group
      shape="button"
      data-shape="button"
      onChange={setSiteLanguage}
      defaultValue={siteLanguage}
      style={{ marginBottom: '16px' }}
    >
      <Radio id="en" value="en">
        {$i18n.get({
          id: 'aopf.pages.settings.en',
          dm: '英文',
        })}
      </Radio>
      <Radio id="zh" value="zh">
        {$i18n.get({
          id: 'aopf.pages.settings.zh',
          dm: '中文',
        })}
      </Radio>
    </Radio.Group>
  );

  //展开和折叠
  const onExpand = (expandedKey: Array<string>, extra: Object) => {
    setExpandedKeys(expandedKey);
  };

  // 拖拽
  const onDrop = (info) => {
    if (!info.dragNode) {
      return;
    }

    // 被拖动的节点key
    const dragKey = info.dragNode.props.eventKey;
    // 放置的节点key
    const dropKey = info.node.props.eventKey;
    // 拖拽的分类 0:移动到某节点的子级，添加到drop.children的最后；1：放置在某节点的后面；-1:放置在某节点的前面
    const dropPosition = info.dropPosition;

    const data = [...dataSource];
    let dragObj;

    _loop(data, dragKey, (item, index, arr) => {
      arr.splice(index, 1);
      dragObj = item;
    });

    if (info.dropPosition === 0) {
      _loop(data, dropKey, (item) => {
        item.children = item.children || [];
        item.children.push(dragObj);
      });
    } else {
      // dropKey所在数组
      let ar;
      // dropKey在所在数组的index
      let i;
      _loop(data, dropKey, (item, index, arr) => {
        ar = arr;
        i = index;
      });
      if (dropPosition === -1) {
        ar.splice(i, 0, dragObj);
      } else {
        ar.splice(i + 1, 0, dragObj);
      }
    }

    setDataSource(data);
  };

  // 编辑name
  const edit = (item) => {
    setEditKey(item?.key);
    // setIsEdit(true);
  };

  // 编辑name失去焦点时
  const onBlur = (e: Event, item) => {
    setEditKey(null);
    // setIsEdit(false);

    const editValue = (e.target as HTMLInputElement)?.value;
    const editItemKey = item?.key;

    const data = [...dataSource];

    _loop(data, editItemKey, (item) => {
      item!.label = editValue;
    });

    setDataSource(data);
  };

  // 删除节点
  const deleteItem = useCallback(
    (item) => {
      const editItemKey = item?.key;

      const data = [...dataSource];
      // // 删除节点所在数组
      // let ar;
      // // 删除节点所在数组的index
      // let i;
      _loop(data, editItemKey, (item, index, arr) => {
        // ar = arr;
        // i = index;

        arr.splice(index, 1);
      });

      setDataSource(data);
    },
    [dataSource],
  );

  // 添加一个根节点
  const addRootNode = () => {
    const newKey = Math.floor(Math.random() * 1000000).toString();
    setDataSource([...dataSource, { key: newKey }]);

    Message.success({
      title: $i18n.get({
        id: 'aopf.pages.settings.document.setting.addNode.success',
        dm: '添加节点成功',
      }),
    });
  };

  // 为当前节点追加一个子节点
  const addChildNode = (currentKey) => {
    const data = [...dataSource];
    _loop(data, currentKey, (item, index, arr) => {
      const children = item?.children || [];
      const newKey = Math.floor(Math.random() * 1000000).toString();
      children.push({ key: newKey });
      item.children = children;
    });
    setDataSource(data);

    // 当前节点为折叠则展开
    const expandedKeysCp = [...expandedKeys];
    const isExpended = expandedKeysCp.some((i) => i === currentKey);
    if (!isExpended) {
      expandedKeysCp.push(currentKey);
      setExpandedKeys(expandedKeysCp);
    }

    Message.success({
      title: $i18n.get({
        id: 'aopf.pages.settings.document.setting.addNode.success',
        dm: '添加节点成功',
      }),
    });
  };

  // 上传成功
  const onSuccess = (value) => {
    _loop(dataSource, editDocumentKey, (item, index, arr) => {
      item.document[siteLanguage] = value;
    });
    Message.success({
      title: $i18n.get({
        id: 'aopf.pages.miniapp.versions.File.Upload.Upload.successfully',
        dm: '上传成功',
      }),
    });
  };

  //上传失败
  const onError = () => {
    Message.error({
      title: $i18n.get({
        id: 'aopf.pages.miniapp.drawer.form.icon.Upload.failure',
        dm: '上传失败',
      }),
    });
  };

  // 上传实例
  const uploader = new Upload.Uploader({
    action: 'http://127.0.0.1:6001/upload.do',
    onSuccess: onSuccess,
    onError: onError,
    name: 'data',
  });

  // 选择文件上传
  const onSelect = (files, key) => {
    setEditDocumentKey(key);

    // TODO:本地测试（需删除）
    const data = [...dataSource];
    _loop(data, key, (item, index, arr) => {
      item.document[siteLanguage] = files[0].name;
    });
    setDataSource(data);

    // 自动上传
    uploader.startUpload(files[0]);
  };

  // 删除文件
  const deleteItemDocument = (key) => {
    const data = [...dataSource];
    _loop(data, key, (item, index, arr) => {
      item.document[siteLanguage] = '';
    });
    setDataSource(data);
  };

  const getTreeNodeLabel = (item) => {
    return (
      <div className={styles.labelContainer} key={item.key}>
        {editKey === item?.key ? (
          <Input
            defaultValue={item?.label}
            onBlur={(e) => {
              onBlur(e, item);
            }}
            onPressEnter={(e) => {
              onBlur(e, item);
            }}
            autoFocus
          />
        ) : (
          <div>
            <span className={styles.treeNodeLabel}>{item.label}</span>
            <span onClick={edit.bind(null, item)} className={styles.editIcon}>
              <Icon type="edit--filled" />
            </span>
          </div>
        )}
        <div className={styles.rightContainer}>
          <div>
            {item.document?.[siteLanguage] ? (
              <>
                <span>{item.document?.[siteLanguage]}</span>
                <span>
                  <Icon
                    type="trash-can--outline"
                    onClick={deleteItemDocument.bind(null, item.key)}
                  />
                </span>
              </>
            ) : (
              <Upload.Selecter
                onSelect={(files) => {
                  onSelect(files, item.key);
                }}
                accept={'.pdf'}
              >
                <div className={styles.addDocumentTitle}>
                  {$i18n.get({
                    id: 'aopf.pages.settings.document.setting.upload',
                    dm: '添加关联文档',
                  })}
                </div>
              </Upload.Selecter>
            )}
          </div>
          <div className={styles.actionContainer}>
            <Confirm
              trigger={
                <div className={styles.deleteBtn}>
                  {$i18n.get({
                    id: 'aopf.pages.invitation.actionDeleteTitle',
                    dm: '删除',
                  })}
                </div>
              }
              dialogTitle={$i18n.get({
                id: 'aopf.pages.invitation.actionDeleteTitle',
                dm: '删除',
              })}
              dialogContent={$i18n.get({
                id: 'aopf.pages.channel.channelList.message.deleteContent',
                dm: '确定删除该内容？',
              })}
              onClick={deleteItem.bind(null, item)}
            />
            <div onClick={addChildNode.bind(null, item.key)}>
              <Tooltip trigger={'Add'} align="t">
                {$i18n.get({
                  id: 'aopf.pages.settings.document.setting.addChildNode',
                  dm: '为当前节点追加子节点',
                })}
              </Tooltip>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // 循环子节点
  const loop = (data) =>
    data.map((item) => {
      if (item.children) {
        return (
          <TreeNode key={item.key} label={getTreeNodeLabel(item)}>
            {loop(item.children)}
          </TreeNode>
        );
      }
      return <TreeNode key={item.key} label={getTreeNodeLabel(item)}></TreeNode>;
    });

  return (
    <div className={styles.documentSettings}>
      <div className={styles.title}>
        {$i18n.get({
          id: 'aopf.pages.settings.title.document.setting',
          dm: '文档设置',
        })}
      </div>
      {siteLanguageRadio}
      <TreeHeader />
      <Tree
        draggable
        selectable={false}
        isLabelBlock
        expandedKeys={expandedKeys}
        onExpand={setExpandedKeys}
        onDrop={onDrop}
        // onDragEnter={(info) => {
        //   setExpandedKeys(info?.expandedKeys);
        // }}
        // renderChildNodes={(nodes) => {
        //   return nodes;
        // }}
      >
        {loop(dataSource)}
      </Tree>
      <div className={styles.addItemIcon}>
        <Tooltip trigger={<Icon type="add--circle--filled" onClick={addRootNode} />} align="t">
          {$i18n.get({
            id: 'aopf.pages.settings.document.setting.addRootNode',
            dm: '添加一个根节点',
          })}
        </Tooltip>
      </div>
      <div className={styles.buts}>
        <Button type="primary">
          {$i18n.get({ id: 'aopf.pages.miniapp.version.info.confirm.Ok', dm: '确定' })}
        </Button>
        <Button type="secondary">
          {$i18n.get({ id: 'aopf.pages.miniapp.version.info.confirm.Cancel', dm: '取消' })}
        </Button>
      </div>
    </div>
  );
}
